export { default } from './Pagination';
export { default as usePagination } from './usePagination';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/Pagination/index.js
// module id = 884
// module chunks = 2